import styled from '@emotion/styled';
import Image from 'next/image';

const LogoImage = styled(Image)({
  marginTop: 20,
  marginBottom: 22.44
});

export default LogoImage;
